import 'css-chunk:src/cms/testimonial/testimonial.module.scss';export default {
  "heading-xxl": "testimonial-module__heading-xxl___H-B2G",
  "wrapper": "testimonial-module__wrapper___cdrKR",
  "heading-xl": "testimonial-module__heading-xl___yWcDj",
  "heading-lg": "testimonial-module__heading-lg___WzOGy",
  "heading-md": "testimonial-module__heading-md___hlAL8",
  "heading-sm": "testimonial-module__heading-sm___u1Uom",
  "heading-xs": "testimonial-module__heading-xs___L5BC9",
  "body-one": "testimonial-module__body-one___MNq8i",
  "body-two": "testimonial-module__body-two___1vlKY",
  "body-three": "testimonial-module__body-three___EGK-v",
  "body-four": "testimonial-module__body-four___Iry1P",
  "overline-one": "testimonial-module__overline-one___tX1XY",
  "overline-two": "testimonial-module__overline-two___4hsfO",
  "overline-three": "testimonial-module__overline-three___1c9wa",
  "strong": "testimonial-module__strong___7B6RV",
  "em": "testimonial-module__em___MDqk6",
  "figcaption": "testimonial-module__figcaption___TbQ-S",
  "no-margin": "testimonial-module__no-margin___6g1o-",
  "testimonial": "testimonial-module__testimonial___ZrOH8",
  "testimonialQuoteIcon": "testimonial-module__testimonialQuoteIcon___RYMUZ",
  "testimonial-background-dark": "testimonial-module__testimonial-background-dark___E8NJj",
  "testimonial-background-primary": "testimonial-module__testimonial-background-primary___DXb5e"
};